import 'bootstrap';
import 'jquery';
import 'mmenu-js';
import browserUpdate from 'browser-update'
import 'slick-carousel/slick/slick';

jQuery(document).ready(function () {
    jQuery('.gallery-small__slider, .guests-slider').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 767,
                settings:  {
                    slidesToShow: 1
                }
            }
        ]
    })
    jQuery('.ho-gallery').slick({
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 767,
                settings:  {
                    slidesToShow: 1
                }
            }
        ]
    })
    jQuery('.room-slider').slick({
        arrows: true,
        fade: true,
        prevArrow: '<img class="arrow-left" src="/wp-content/themes/zamek-theme/dist/img/arrow-left.png">',
        nextArrow: '<img class="arrow-right" src="/wp-content/themes/zamek-theme/dist/img/arrow-right.png">',
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: false
                }
            }
        ]
    })

    jQuery('.opinions-slider').slick({
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 4000,
        infinite: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    })
    const height = jQuery('.opinions-slider .slick-track').height()
    if (window.innerWidth > 767)
    jQuery('.opinions-slider .slick-slide').css('height', height)

    function showMoreContent(element, buttons) {
        jQuery(buttons).on('click', function () {
            let off = window.pageYOffset
            jQuery(buttons).removeClass('d-none')
            jQuery(this).addClass('d-none')
            jQuery(element).toggleClass('d-none')
            window.scrollTo(0, off)
        })
    }

    showMoreContent('.more-catering-1', '.catering-action-buttons-1 button')
    showMoreContent('.more-catering-2', '.catering-action-buttons-2 button')
    showMoreContent('.hidden-chef-desc', '.chef-action-buttons button')
    showMoreContent('.menu-action', '.menu-action-buttons button')
    showMoreContent('.breakfast_row', '.breakfast-action-buttons button')
    showMoreContent('.treatment-hide', '.treatment-action-buttons button')
    showMoreContent('.hidden-history', '.history-action-buttons button')
    showMoreContent('.action-interview', '.interview-action-buttons button')
    showMoreContent('.action-charity', '.charity-action-buttons button')
    showMoreContent('.action-attraction', '.attractions-action-buttons button')
    showMoreContent('.action-monuments', '.monuments-action-buttons button')

    jQuery('.gallery-small__charity').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: false,
        responsive: [{
            breakpoint: 991,
            settings: {
                slidesToShow: 2
            }
        }]
    })

    jQuery('.charity-action-buttons button').on('click', function () {
        jQuery('.gallery-small__charity').slick('setPosition')
    })

    jQuery('table').addClass('table-responsive')

})
document.addEventListener('DOMContentLoaded', () => {

    //browser Update

    browserUpdate({
        required: {
            e: 0,
            i: 0,
            c: 0,
            f: 0,
            o: 0,
            o_a: 0,
            s: 0,
            y: 0,
            v: 0,
            uc: 0,
            ios: 0,
            samsung: 0
        },
        insecure: true
    });

    //mMenu.js
    const mMenu = document.getElementById('mobile-menu');
    if (mMenu)
        new Mmenu("#mobile-menu", {
            "extensions": [
                "pagedim-black",
                "theme-dark"
            ],
            "counters": true
        });

    const navbar = document.getElementById("header")
    const sticky = navbar.offsetTop
    const submenu = document.getElementById('submenu')

    if (submenu) {
        let st = submenu.offsetTop - 140
        window.onscroll = function () {
            stickyHeader(st, submenu)
            stickyHeader(sticky, navbar)
        }
    } else {
        window.onscroll = function () {
            stickyHeader(sticky, navbar)
        };
    }

    function stickyHeader(st, nav) {
        if (window.pageYOffset > st) {
            nav.classList.add("sticky")
        } else {
            nav.classList.remove("sticky")
        }
    }

    function menuAction(selector) {
        const links = document.querySelectorAll(selector)
        if (links) {
            links.forEach(item => {
                item.addEventListener('click', function (e) {
                    e.preventDefault();
                    const hash = item.href.split('#').pop()
                    const height = document.getElementById(hash).offsetTop - 200
                    window.scrollTo(0, height)
                })
            })
        }
    }

    menuAction('.current-menu-item ul a')
    menuAction('.submenu li a')


});